import * as React from "react";
import * as ReactDOM from "react-dom";

interface IProperties
{
    /**
     * Child Elemente.
     */
    children: JSX.Element | JSX.Element[],

    /**
     * Inline-Style.
     */
    style?: React.CSSProperties,


    direction?: "horizontal" | "vertical"
}

export class Navigation extends React.Component<IProperties>
{
    public static defaultProps: Partial<IProperties> = {
        direction: "horizontal"
    };

    /**
     * Rendert diese Komponente.
     */
    public render(): JSX.Element
    {
        const { children, style, direction } = this.props;
        const classNames: string[] = ["nav"]

        if (direction === "horizontal")
            classNames.push("nav--direction-h");
        else
            classNames.push("nav--direction-v");

        return (
            <nav
                className={classNames.join(" ")}
                style={style} >
                {children}
            </nav>
        );
    }
}